import { EndpointErrorMessagesType } from './ErrorHandlingMessages';

export const TicketRequestErrorMessages: EndpointErrorMessagesType = {
  400: { default: 'error:ticketRequest400Default' },
  404: { default: 'error:ticketRequest404Default' },
  500: { default: 'Error 500' },
};
